import React from "react";
import { CircularProgress, DialogContent, Typography } from "@mui/material";
import CommonButtons from "../CommonButtons";
import { ModalWrapper } from "src/shared/components/ModalWrapper"; // adjust path if needed

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isProcessing?: boolean;
  disableConfirm?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, description, confirmLabel = "Confirm", cancelLabel = "Cancel", isProcessing = false,disableConfirm = false, onConfirm, onCancel }) => {
  if (!open) return null; // ✅ Return null when modal is closed

  return (
    <ModalWrapper title={title} onClose={onCancel} showCloseButton width="max-w-lg" useTheme>
      {/* Body */}
      <DialogContent sx={{ py: 3 }}>
      <Typography variant="body1" className="mb-6" style={{ fontFamily: "inherit" }}>
        {description}
      </Typography>
      </DialogContent>

      {/* Actions */}
      <div className="flex justify-end items-center gap-3">
        <CommonButtons className="w-32 h-10" label={cancelLabel} variant="outlineDanger" onClick={onCancel} disabled={isProcessing} />
        <CommonButtons className="w-32 h-10" label={confirmLabel} onClick={onConfirm} disabled={isProcessing || disableConfirm} />
        {isProcessing && <CircularProgress size={24} />}
      </div>
    </ModalWrapper>
  );
};

export default ConfirmDialog;
